module.exports = __webpack_public_path__ + "img/30x30_sari.b31f0674.gif";